export const fr = {
  // Header
  header: {
    title: "Remplacement de voix simple et rapide dans votre vidéo, dans n'importe quelle langue !",
    subtitle: "🔥Payez seulement pour les résultats – seulement 0.099 $ par seconde.🔥"
  },

  // Steps
  steps: {
    uploadVideo: "Télécharger Vidéo",
    selectLanguages: "Sélectionner Langues", 
    conversionResult: "Conversion et Résultat"
  },

  // Upload section
  upload: {
    dragAndDrop: "Glissez et déposez votre fichier vidéo ici",
    orClickToSelect: "ou cliquez pour sélectionner",
    supportedFormats: "Formats supportés : MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Taille maximale du fichier : 250 Mo",
    maxDuration: "• Durée maximale : 15 min",
    processingTime: "• Le traitement prendra de 2 à 15 minutes selon la résolution vidéo",
    chooseFile: "Choisir Fichier",
    selectedFile: "Fichier sélectionné :",
    size: "Taille :",
    fileTypeError: "Veuillez sélectionner un fichier vidéo",
    fileSizeError: "La taille du fichier ({size} Mo) dépasse la limite maximale de 250 Mo",
    durationError: "La durée de la vidéo ({duration} minutes) dépasse la limite maximale de 15 minutes",
    fileReadError: "Impossible de lire le fichier vidéo. Veuillez essayer un fichier différent."
  },

  // Language selection
  languages: {
    sourceAudioLanguage: "Langue audio source",
    targetAudioLanguage: "Langue audio cible",
    selectLanguage: "Sélectionner langue..."
  },

  // Language options
  languageOptions: {
    ru: "Russe",
    en: "Anglais",
    es: "Espagnol",
    fr: "Français",
    de: "Allemand",
    it: "Italien",
    pt: "Portugais",
    pl: "Polonais",
    zh: "Chinois",
    ja: "Japonais",
    ko: "Coréen",
    bg: "Bulgare",
    hr: "Croate",
    cs: "Tchèque",
    da: "Danois",
    nl: "Néerlandais",
    et: "Estonien",
    fi: "Finnois",
    el: "Grec",
    hu: "Hongrois",
    ga: "Irlandais",
    lv: "Letton",
    lt: "Lituanien",
    mt: "Maltais",
    ro: "Roumain",
    sk: "Slovaque",
    sl: "Slovène",
    sv: "Suédois"
  },

  // Conversion
  conversion: {
    replaceAudio: "Remplacer Audio",
    uploadVideoAndSelectLanguages: "Téléchargez une vidéo et sélectionnez les langues pour continuer",
    fixValidationError: "Veuillez corriger l'erreur de validation du fichier ci-dessus",
    createSubtitles: "Créer des Sous-titres",
    uploadVideoForSubtitles: "Téléchargez une vidéo pour créer des sous-titres",
    selectTranslationLanguage: "Sélectionnez la langue de traduction"
  },

  // Demo video section
  demo: {
    seeVeviInAction: "Voir VEVI en Action",
    watchHowItWorks: "Regardez comment fonctionne notre technologie de remplacement de voix IA",
    beforeEnglish: "Avant (Anglais)",
    originalPresentation: "Présentation corporate originale",
    afterSpanish: "Après (Espagnol,Français, Chinois, Italien)",
    aiTranslatedVoice: "Traduit par IA avec voix naturelle",
    demoTitle: "Démo - VEVI en Action"
  },

  // Reviews
  reviews: {
    title: "Ce Que Disent Nos Clients",
    subtitle: "Fait confiance par des professionnels du marketing dans le monde entier",
    customerReviews: [
      {
        name: "Sarah Johnson",
        position: "Gestionnaire Marketing Numérique",
        company: "TechFlow Solutions",
        text: "VEVI a transformé nos campagnes marketing internationales ! Nous avons localisé nos vidéos de démonstration produit pour 8 marchés différents en seulement une journée. La qualité est incroyable et les prix sont si transparents."
      },
      {
        name: "Michael Chen",
        position: "Directeur Marketing de Contenu", 
        company: "GlobalReach Media",
        text: "En tant que personne qui gère le contenu vidéo pour plusieurs régions, VEVI change la donne. Le remplacement de voix est si naturel que nos audiences ne peuvent pas dire que c'est généré par IA. Hautement recommandé !"
      },
      {
        name: "Emma Rodriguez",
        position: "Spécialiste Marketing de Marque",
        company: "InnovateCorp",
        text: "Nous avons économisé des milliers sur les coûts de voix-off tout en nous étendant sur de nouveaux marchés. Le prix de 0,029 $ par seconde est incroyablement équitable, et les résultats parlent d'eux-mêmes. Nos taux de conversion ont augmenté de 40% !"
      },
      {
        name: "David Thompson",
        position: "Gestionnaire Campagnes Marketing",
        company: "NextGen Brands",
        text: "La vitesse et la qualité de VEVI sont inégalées. Nous sommes passés d'une vidéo en anglais à 12 versions localisées en différentes langues en quelques heures. Cet outil est essentiel pour le marketing global."
      },
      {
        name: "Lisa Park",
        position: "Leader Marketing Réseaux Sociaux",
        company: "CreativeEdge Agency",
        text: "VEVI a rendu possible pour notre petite agence d'offrir des services vidéo multilingues aux clients. La qualité est de niveau professionnel et le processus est incroyablement simple. Nos clients adorent les résultats !"
      },
      {
        name: "James Wilson",
        position: "Directeur Marketing Performance",
        company: "ScaleUp Ventures",
        text: "Le ROI est tout dans le marketing de performance, et VEVI livre. Nous avons réduit nos coûts de localisation vidéo de 80% tout en améliorant le délai d'exécution de semaines à heures. Cet outil se paie immédiatement."
      }
    ]
  },

  // Payment dialog
  payment: {
    title: "Paiement de Conversion",
    processingCost: "Coût de Traitement",
    duration: "Durée :",
    baseCost: "Coût de base",
    discount: "Remise ({promoCode}) :",
    discountAmount: "Montant de remise :",
    total: "Total :",
    emailToReceiveResult: "Email pour recevoir le résultat",
    emailPlaceholder: "votre-email@exemple.com",
    promoCode: "🎟️ Code Promo (optionnel)",
    promoCodePlaceholder: "Entrez le code promo",
    check: "Vérifier",
    checking: "Vérification...",
    addSubtitles: "Ajouter des sous-titres à la vidéo",
    addSubtitlesDescription: "Générer et intégrer des sous-titres dans la langue cible",
    highQualityTranslation: "• Traduction IA de haute qualité",
    originalVideoPreserved: "• Vidéo originale préservée",
    fastProcessing: "• Traitement rapide (typiquement 5-10 minutes)",
    resultWillBeSent: "• Le résultat sera envoyé à l'email spécifié",
    cancel: "Annuler",
    continue: "Continuer",
    enterEmail: "Veuillez entrer votre email",
    enterValidEmail: "Veuillez entrer une adresse email valide",
    enterPromoCode: "Veuillez entrer un code promo",
    invalidPromoCode: "Code promo invalide",
    validPromoCode: "Code promo valide ! Remise de {discount}% appliquée"
  },

  // Progress dialog
  progress: {
    title: "Traitement Vidéo",
    uploadingAndExtracting: "🎬 Téléchargement et extraction audio",
    transcribingAndTranslating: "🗣️ Transcription de la parole et traduction", 
    synthesizingAudio: "🎵 Synthèse nouvelle piste audio",
    step: "Étape :",
    error: "Erreur"
  },

  // Result dialog
  result: {
    title: "Terminé ! Votre vidéo a été traitée",
    conversionCompleted: "Conversion terminée avec succès !",
    processedVideoDescription: "🎬 Votre vidéo traitée avec clonage de voix",
    payAndDownload: "Payer et Télécharger",
    videoNotAvailable: "Vidéo non disponible",
    useDownloadButton: "Veuillez utiliser le bouton de téléchargement ci-dessous",
    downloadError: "Erreur de Téléchargement"
  },

  // Email sent dialog
  emailSent: {
    title: "Vidéo Envoyée ! 🎉",
    videoOnWay: "La vidéo est déjà en route vers votre email 🙏❤️",
    checkInbox: "Vérifiez votre boîte de réception et dossier spam. La vidéo traitée arrivera bientôt !",
    whatsNext: "Et maintenant ?",
    checkEmail: "• Vérifiez votre email ({email})",
    checkSpam: "• Regardez dans le dossier spam/courrier indésirable si non trouvé",
    downloadAndEnjoy: "• Téléchargez et profitez de votre vidéo doublée !",
    close: "Fermer",
    processAnotherVideo: "Traiter Une Autre Vidéo"
  },

  // Processing steps
  processingSteps: {
    uploading: "Téléchargement vidéo...",
    extracting: "Extraction audio...",
    transcribing: "Transcription parole...",
    translating: "Traduction contenu...",
    synthesizing: "Synthèse nouvelle voix...",
    rendering: "Rendu vidéo finale...",
    complete: "Traitement terminé !"
  },

  // Common
  common: {
    minutes: "minutes",
    seconds: "secondes",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès"
  },

  // Social media
  socialMedia: {
    title: "Restez Connecté",
    description: "Obtenez les dernières mises à jour sur la technologie de voix avec IA"
  },

  // Services (for Footer)
  services: {
    dubbing: "Doublage",
    voiceClone: "Doublage avec clonage de voix",
    newVoice: "Doublage avec nouvelle voix",
    multilingual: "Doublage multilingue",
    multiSpeaker: "Doublage multi-locuteur",
    subtitles: "Sous-titres",
    subtitlesOnly: "Sous-titres uniquement",
    multilingualSubtitles: "Sous-titres multilingues",
    subtitlesDescription: "Générez automatiquement des sous-titres précis pour n'importe quelle plateforme.",
    subtitlesPrice: "Coût de traitement: $0.01/sec",
    addSubtitles: "Ajouter des sous-titres",
    needsTranslation: "Besoin de traduction?",
    translationLanguage: "Langue de traduction"
  },

  // Footer
  footer: {
    legal: "Mentions légales",
    privacyPolicy: "Politique de confidentialité",
    termsOfUse: "Conditions d'utilisation"
  },

  // Navigation
  nav: {
    blog: "Blog"
  },

  // Blog
  blog: {
    title: "Blog VEVI Monster",
    subtitle: "Histoire et mythologie de l'univers VEVI",
    readMore: "Lire la suite",
    backToBlog: "Retour au blog",
    articleNotFound: "Article non trouvé",
    characteristics: "Caractéristiques",
    articles: {
      "vevi-monster": {
        title: "VEVI Monster",
        excerpt: "Vevi est un être né des tourbillons de plasma de Zera-13b. Il n'est ni chair ni métal—son corps est constitué de particules vibrantes maintenues ensemble par un champ électromagnétique.",
        metadata: {
          "Galaxie": "MoM-z14",
          "Âge": "13,4 milliards d'années",
          "Type": "Planète rocheuse avec une atmosphère dense de méthane et de néon",
          "Étoile": "Protostar rouge Zera-13",
          "Orbite": "Deuxième planète du système",
        },
        content: [
          "🌑 Description",
          "Zera-13b est un monde ancien et presque oublié, né à une époque où l'Univers apprenait juste à briller.",
          "Son ciel scintille de flammes vertes ternes, et l'atmosphère dense tremble des tempêtes de néon. La surface est un paysage noir-gris couvert de cratères vitreux où les vents de méthane laissent des traces de feu dans l'air.",
          "Sous la surface se trouvent des grottes de gaz gelé, où, selon les légendes, les premières formes d'énergie capables de penser sont nées.",
          "👾 Vevi (Vevi Monster)",
          "Vevi est un être né des tourbillons de plasma de Zera-13b.",
          "Il n'est ni chair ni métal—son corps est constitué de particules vibrantes maintenues ensemble par un champ électromagnétique.",
          "Ses yeux brillent de la lumière réfléchie de l'étoile Zera-13, et sa voix sonne comme le murmure du vent de néon.",
          "Vevi a quitté son monde lorsque la protostar a commencé à s'estomper. Il a voyagé à travers des vides intergalactiques, guidé par l'instinct de rechercher une nouvelle énergie.",
          "Maintenant, il erre à travers les mondes, portant avec lui une particule de la lumière primordiale de Zera-13b.",
          "La lueur lui est venue de la planète",
          "Il n'a pas de jambes—parce que la planète a une gravité énorme et il lévite simplement",
          "Il communique (ou plutôt émet des sons) similaires aux ondes acoustiques des dauphins, baleines et orques.",
          "Sa langue s'appelle UFOnic",
        ],
      },
      "baddy-sub": {
        title: "Baddy Sub",
        excerpt: "Baddy Sub est un être de l'Univers primitif, né dans Sub Zone, une région rare de l'espace avec une haute densité de matière.",
        metadata: {
          "Nom de l'objet": "Sub Zone (SUB-Z)",
          "Type d'objet": "Protocluster / région de formation de galaxies",
          "Époque": "~200–300 millions d'années après le Big Bang",
          "Décalage vers le rouge": "z ≈ 14–15",
          "Ascension droite (RA)": "02h 17m 43s",
          "Déclinaison (Dec)": "−04° 12′ 09″",
        },
        content: [
          "Données Baddy Sub",
          "Corps long, mince et oblong avec deux membres inférieurs en bas et trois yeux sur des formes étendues en haut",
          "Il n'a pas de bouche.",
          "Il y a aussi deux membres supérieurs minces qui peuvent être interprétés comme des bras.",
          "Deux doigts sur chaque membre.",
          "Tout le corps ressemble à une branche d'arbre",
          "La peau a une structure mate lisse",
          "La couleur est vert-brun (pigmentation)",
          "Peut changer de couleur selon l'environnement comme un caméléon.",
          "Description de la planète où Baddy Sub est né:",
          "Sub Zone est une région rare de l'Univers primitif avec une haute densité de matière, où les premières structures galactiques ont commencé à se former. Les observations indiquent des interactions intenses de gaz primordial, de rayonnement et d'ondes gravitationnelles. La région a enregistré des modèles de signal instables et une activité résonnante anormale, non caractéristique des régions protogalactiques typiques.",
          "Signification scientifique:",
          "Sub Zone est considéré comme un objet clé pour étudier les premiers stades de l'assemblage des galaxies, la propagation des signaux dans l'Univers jeune et la transition des champs de rayonnement chaotiques aux systèmes cosmiques structurés.",
          "Statut:",
          "Classé comme région de formation non résolue. Des recherches supplémentaires sont nécessaires.",
        ],
      },
    },
  },

  // FAQ
  faq: {
    title: "Questions Fréquemment Posées",
    subtitle: "Tout ce que vous devez savoir sur VEVI",
    questions: [
      {
        question: "Travaillez-vous uniquement avec la voix?",
        answer: "Oui — nous remplaçons votre voix pour qu'elle sonne dans une autre langue tout en restant naturelle et authentique."
      },
      {
        question: "Je paie avant ou après?",
        answer: "Après. Vous entendez d'abord le résultat, puis vous payez."
      },
      {
        question: "Remboursements?",
        answer: "Pas nécessaire — vous ne payez que lorsque vous êtes satisfait du résultat."
      },
      {
        question: "Vidéo de plus de 5 minutes?",
        answer: "Pas de problème. Demandez à notre assistant IA dans le chat en ligne pour obtenir des instructions."
      },
      {
        question: "Puis-je choisir une autre voix?",
        answer: "Non — nous ne clonons que votre propre voix."
      },
      {
        question: "Paiement minimum?",
        answer: "À partir de $0.50."
      },
      {
        question: "Comment obtenir ma vidéo?",
        answer: "Téléchargement instantané dans votre navigateur + copie envoyée à votre email après paiement."
      },
      {
        question: "Remises pour les grandes commandes?",
        answer: "Oui — contactez notre assistant IA dans le chat en ligne."
      },
      {
        question: "Vous n'avez pas trouvé votre réponse?",
        answer: "Demandez à notre assistant IA dans le chat en ligne — nous sommes là pour vous aider."
      },
      {
        question: "Format non supporté?",
        answer: "Utilisez un convertisseur ou obtenez une aide rapide de notre assistant IA dans le chat en ligne."
      },
      {
        question: "Ma vidéo contient des termes spécifiques qui doivent être prononcés correctement. Puis-je contrôler cela?",
        answer: "Oui — envoyez simplement un message à notre assistant IA dans le chat en ligne, et nous vous enverrons des instructions sur la façon de marquer ou de préserver certains termes (par exemple, les laisser en anglais)."
      },
      {
        question: "Je n'ai pas reçu mon email. Que dois-je faire?",
        answer: "Le temps de traitement peut varier en fonction du volume de la file d'attente. Ne vous inquiétez pas — votre fichier est en sécurité. Vous recevrez soit une notification, soit un lien de téléchargement direct une fois qu'il sera prêt."
      }
    ]
  }
};
